import React from 'react';
import { motion } from 'framer-motion';

export const PulsingRing = ({ x, y, color }) => (
  <g>
    <motion.circle
      cx={x} cy={y} r="50"
      fill="none"
      stroke={color}
      strokeWidth="2"
      initial={{ scale: 0.6, opacity: 0.8 }}
      animate={{ scale: 1.6, opacity: 0 }}
      transition={{ duration: 2, repeat: Infinity, ease: "easeOut" }}
    />
    <motion.circle
      cx={x} cy={y} r="50"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      initial={{ scale: 0.5, opacity: 0.5 }}
      animate={{ scale: 1.9, opacity: 0 }}
      transition={{ duration: 2, repeat: Infinity, ease: "easeOut", delay: 0.6 }}
    />
  </g>
);
